// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-m_hq","advertDetailParameterList__header":"c-m_hr","advertDetailParameterList__list":"c-m_hs"};